import React from "react";
import { useTranslation } from 'react-i18next';
import styles from "./type-of-objects-card.module.scss"
import CardButton from "../../../cities/city-cards/city-card-buttons/card-button/card-button";

export enum TypeCases {
    Lands = "lands",
    Spaces = "spaces",
    Investment = "investment"
}

interface Props {
    typeCase: TypeCases;
    value: number;
    onClick: any;
}

const TypeOfObjectCard = ({typeCase, value, onClick}: Props) => {
    const { t } = useTranslation();
    const casesContent = {
        [TypeCases.Lands]: {
            title: t('type-of-objects-card.lands.title'),
            description: t('type-of-objects-card.lands.description')
        },
        [TypeCases.Spaces]: {
            title: t('type-of-objects-card.spaces.title'),
            description: t('type-of-objects-card.spaces.description')
        },
        [TypeCases.Investment]: {
            title: t('type-of-objects-card.investment.title'),
            description: t('type-of-objects-card.investment.description')
        }
    }

    const renderButton = () => {
        switch (typeCase) {
            case TypeCases.Lands: {
                return <CardButton onClick={onClick} count={value} buttonName={t('type-of-objects-card.lands.button')}/>
            }
            case TypeCases.Spaces: {
                return <CardButton onClick={onClick} count={value} buttonName={t('type-of-objects-card.spaces.button')}/>
            }
            case TypeCases.Investment: {
                return <CardButton className={styles.investment} onClick={onClick} count={value} buttonName={t('type-of-objects-card.investment.button')}/>
            }
        }
    }

    return (
        <div onClick={onClick} className={styles.container}>
            <h2 className={styles[typeCase]}>{casesContent[typeCase].title}</h2>
            {renderButton()}
            <p>{casesContent[typeCase].description}</p>
        </div>
    )
}

export default TypeOfObjectCard
